import { INode } from 'shared/types/tree'

export const SheetParamKey = 'sheetId'
export type SummaryType = 'short' | 'long'

export type PathData = { nodeType: string; nodeTitle: string }

export type SummaryData = {
  pathData: PathData[]
  summaryType: SummaryType
  summaryLevel: string
  generations: string
}

export type SummaryMapped = Record<string, SummaryData[]>

export type pathResult = {
  nodeType: string
  nodeTitle: string
  found: string | undefined
}

export type nodeSearchResult = {
  node: INode | undefined
  pathResult: pathResult[]
}

export type unMappedData = {
  summary: SummaryData
  pathResult: pathResult[]
}

export type SummaryMapping = {
  mapped: SummaryMapped
  unMapped: unMappedData[]
  done: SummaryMapped
}

export type CourseSummaryMapping = {
  curriculumTitle: string
  treeId: string
  summaryData: SummaryData[]
}

export type SummaryCSVData = {
  curriculumTitle: string
  summaryLevel: string
  generations: string
  treeId: string
  summary: string
  [key: string]: string | undefined
}
